export default function(ac, app) {
    var tehnicar = app.getEntity('Tehnicar');
    tehnicar.listView()
        .title('Tehničari')
        .icon('<i class="fa fa-users fa-3x"></i>')
        .fields([
            ac.field('naziv', 'template')
                .label('Naziv')
                .template(function (entry) {
                    return `${entry.prezime} ${entry.ime}`;
                })
                .cssClasses(['col-md-11'])
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    tehnicar.editionView()
        .title('Tehničar')
        .fields([
            {
                key:'prezime',
                type: 'hInput',
                templateOptions: {
                    label: 'Prezime',
                    required: true,
                    focus: true
                }
            },
            {
                key: 'ime',
                type: 'hInput',
                templateOptions: {
                    label: 'Ime',
                    required: true
                }
            }
        ]);

    return tehnicar;
}



// WEBPACK FOOTER //
// ./app/components/tehnicar/config.js